import React from "react";
import "./Privacy_Policy.css";
import { Container } from "react-bootstrap";

const Privacy_Policy = () => {
  return (
    <>
      <section className="Privacy_Policy ">
        <div className="privacy-section">
          <div className="container">
            <div className="privacy-header">
              <div className="privacy-header-left">
                <h2 className="privacy-title">Privacy Policy</h2>
              </div>
              <div className="privacy-header-line"></div>
            </div>

            <h4 className="privacy-subtitle">Our Commitment To You</h4>

            <p className="privacy-description">
              At PmRoad, we prioritize your privacy above all else. Our
              commitment to safeguarding your personal information is reflected
              in every aspect of our service, so you can trust us to provide a
              secure and comfortable ride.
            </p>
          </div>
        </div>

        <Container>
          {/* SECTION 1 */}
          <div className="privacy_item">
            <p className="privacy_description">
              Protecting your private information is our priority. This
              Statement of Privacy applies to <span> <a  href="/">www.PmRoad.in </a> </span> & <b>PmRoad Inc.</b> and
              governs data collection & usage. For the purposes of this Privacy
              Policy, unless otherwise noted, all references to PmRoad include
              <span> <a  href="/">www.PmRoad.in </a></span> & <b>PmRoad, Inc.</b> The Shipday website is a restaurant
              food delivery management site. By using the PmRoad website, you
              consent to the data practices described in this statement. This
              Privacy Policy applies to every PmRoad application, whether
              accessed directly or through a third-party marketplace or
              platform.
            </p>
          </div>

          {/* SECTION 2 */}
          <div className="privacy_item">
            <h5 className="privacy_head">
              When a Merchant enables any Company application on a Platform,
              Company acts as a service provider/processor on behalf of that
              Merchant. In this role we:
            </h5>

            <p className="privacy_description">
              1. Collect only the data the Platform makes available or that the
              Merchant provides. <br />
              2. Use that data solely to deliver, secure, and improve the
              application. <br />
              3. Disclose it only to the Merchant and subprocessors and never
              for our own independent marketing purposes. <br />
              4. Retain & secure the data. <br />
              5. Honour data subject rights through the Merchant, who is the
              data controller.
            </p>
          </div>

          {/* SECTION 3 */}
          <div className="privacy_item">
            <h5 className="privacy_head">
              Collection of your Personal Information
            </h5>
            <p className="privacy_description">
              PmRoad may collect personally identifiable information such as
              your name. If you use PmRoad's services, we collect your address,
              phone number, amount purchased, purchase details & primary email
              address. This information is used to complete the delivery
              transaction. Drivers using the driver app also have their location
              collected while online, for navigation and geofencing. When
              offline, location is not collected. Additional technical data such
              as IP address, browser type, domain names, and access times may
              also be collected.
            </p>
          </div>

          {/* SECTION 4 */}
          <div className="privacy_item">
            <h5 className="privacy_head">Use of your Personal Information</h5>
            <p className="privacy_description">
              The PmRoad website may use "cookies" to personalize your online
              experience. Cookies cannot be used to run programs or deliver
              viruses. They are assigned uniquely to you and can only be read by
              the web server that issued them. You may accept or decline
              cookies. However, declining cookies may prevent you from fully
              experiencing certain features of the PmRoad services.
            </p>
          </div>

          {/* SECTION 5 */}
          <div className="privacy_item">
            <h5 className="privacy_head">Use of Cookies</h5>
            <p className="privacy_description">
              The PmRoad website may use cookies to help personalize your online
              experience. Cookies are text files placed on your device by a web
              server and can only be read by the domain that issued them. You
              may accept or decline cookies, but declining may limit your
              experience on the website.
            </p>
          </div>

          {/* SECTION 6 */}
          <div className="privacy_item">
            <h5 className="privacy_head">
              Security of your Personal Information
            </h5>
            <p className="privacy_description">
              Your personal information is extremely important to us. PmRoad
              protects your personal data from unauthorized access, use, or
              disclosure. Data transmitted to other websites is encrypted using
              SSL. Although we take strong security measures, no system is
              entirely free of risks.
            </p>
          </div>

          {/* SECTION 7 */}
          <div className="privacy_item">
            <h5 className="privacy_head">Children Under Thirteen</h5>
            <p className="privacy_description">
              PmRoad does not knowingly collect personal information from
              children under the age of thirteen. If you are under thirteen, you
              must have parental or guardian permission to use this website.
            </p>

            <h6 className="privacy_head">Opt-Out & Unsubscribe</h6>
            <p className="privacy_description">
              Users may opt-out of receiving communications from PmRoad by
              contacting us at www.PmRoad.in.
            </p>

            <h6 className="privacy_head">Changes to this Statement</h6>
            <p className="privacy_description">
              PmRoad may update this Privacy Policy occasionally. You are
              encouraged to review it periodically to stay informed about how we
              protect your information.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Privacy_Policy;
